import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'
import { getTrialsEnabled } from '@/screens/AccessScreen/accessSettings'

/**
 * The channel's trial settings from Access Settings, on the shared `['sponsor', 'info']` query.
 * Trials stay off until sponsor info has loaded, so nothing offers a trial the channel hasn't allowed.
 */
export function useChannelTrials() {
  const { api } = useGlobalState()

  const sponsorInfoQuery = useQuery({
    queryKey: ['sponsor', 'info'],
    queryFn: () => api.getSponsorInfo(),
    staleTime: 5 * 60 * 1000,
  })

  const info = sponsorInfoQuery.data
  const trialsEnabled = info ? getTrialsEnabled(info) : false

  return {
    trialsEnabled,
    /** Whether the invite form's trial option starts checked (the Manual invites default). */
    inviteDefaultTrial: trialsEnabled && info?.manualInviteAccessType === 'free_trial',
    isReady: sponsorInfoQuery.isSuccess,
  }
}
